import { PhoneNumberInput } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { getFormats, useConfig } from '../../../state/configuration'
import { FormInputProps } from '../types'

export const PhoneNumberFormInput: FunctionComponent<FormInputProps<string>> = (
  props,
) => {
  const { value, onChange, tKey, tName, t } = props

  const {
    phoneNumber: { prefix },
  } = useConfig(getFormats)

  return (
    <PhoneNumberInput
      initialValue={value}
      onChange={onChange}
      placeholder={t(tKey(tName, 'placeholder'))}
      internationalCode={prefix}
    />
  )
}
